import { Box, SxProps, Typography } from '@mui/material';
import { FC } from 'react';

interface DocumentSubtitlesProps {
    elements: string[];
}

const subtitleSx: SxProps = {
    '&:not(:last-child)': {
        '&::after': {
            backgroundColor: 'grey.400',
            borderRadius: '50%',
            content: "''",
            display: 'block',
            height: 4,
            position: 'absolute',
            right: 8,
            top: '50%',
            transform: 'translate3d(50%, -50%, 0)',
            width: 4,
        },
        position: 'relative',
        pr: 2,
    },
    color: 'grey.400',
};

const DocumentSubtitles: FC<DocumentSubtitlesProps> = ({ elements }) => (
    <Box display="flex">
        {elements.filter(Boolean).map((element) => (
            <Typography key={element} sx={subtitleSx} variant="body2">
                {element}
            </Typography>
        ))}
    </Box>
);

export default DocumentSubtitles;
